import { useSyncExternalStore } from 'react';

// Startup owns priority over every carousel, regardless of which page mounts it.
const blockers = new Set();
const listeners = new Set();
const notify = () => listeners.forEach(listener => listener());
const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener); };
const snapshot = () => blockers.size > 0;
export const isStartupOverlayActive = snapshot;
export const useStartupOverlayActive = () => useSyncExternalStore(subscribe, snapshot, () => false);

export const acquireStartupOverlay = () => {
  const token = Symbol('startup');
  blockers.add(token);
  notify();
  return () => { if (blockers.delete(token)) notify(); };
};

// A splash can interrupt an already-open carousel; independent overflow restores
// would otherwise unlock scrolling too early or leave it permanently locked.
let scrollLocks = 0;
let originalOverflow = '';
export const lockOverlayScroll = () => {
  if (!scrollLocks) originalOverflow = document.body.style.overflow;
  scrollLocks += 1;
  document.body.style.overflow = 'hidden';
  let released = false;
  return () => {
    if (released) return;
    released = true;
    scrollLocks -= 1;
    if (!scrollLocks) document.body.style.overflow = originalOverflow;
  };
};